<template>
	<div>
		<v-row>
			<v-col cols="12">
				<v-data-table
				ref="dataTable"
				:headers="headers"
				:items="items"
				:loading-text="$t('wkt.admin.common.table.loading')"
				:no-data-text="$t('wkt.admin.common.table.no_data')"
				:no-results-text="$t('wkt.admin.common.table.no_results')"
				class="mt-4 elevation-0"
				fixedHeader
				hide-default-footer
				disable-pagination>
					<template v-slot:[`item`]="{ item }">
						<tr>
							<td>{{ formatLongDateTime(item.ticketDate) }}</td>
							<td style="max-width: 150px;">{{ item.expenseDescription }}</td>
							<td>{{ item.categoryName }}</td>
							<td>{{ getFormatTypeText(item.formatType) }}</td>
							<td>{{ getPaymentMethodText(item.paymentMethod) }}</td>
							<td>{{ formatCurrency(item.taxesPercent) }}%</td>
							<td>{{ formatCurrency(item.grossAmount) }}</td>
							<td>{{ formatCurrency(item.totalAmount) }}</td>
							<td style="max-width: 150px;">
								<a class="text-decoration-underline" @click.stop="$emit('download-document', item)">{{ item.documentName }}</a>
							</td>
							<td>
								<v-btn v-if="[-1,2].includes(parent.status)" text color="#185EA9" class="text-button" @click.stop="$emit('edit-item', item)">{{ $t('wkt.client.expensesheets.detail-window.items.button-edit') }}</v-btn>								
								<v-btn v-if="![-1,2].includes(parent.status)" text color="#185EA9" class="text-button" @click.stop="$emit('view-item', item)">{{ $t('wkt.client.expensesheets.detail-window.items.button-view') }}</v-btn>
							</td>
						</tr>
					</template>
				</v-data-table>
			</v-col>
		</v-row>
	</div>
</template>

<script>
import BaseModule from "../../common/BaseModule.js";

export default {
	name: 'ExpenseSheetItemsTable',
	mixins: [BaseModule],
	props: ['parent','items'],
	components: {
	},
	data () {
		return {
			headers: [
                //{ text: this.$t("wkt.client.expensesheets.table.headers.id"), value: 'id', width: '8%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.ticket_date"), value: 'ticketDate', width: '15%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.expense_description"), value: 'expenseDescription', width: '25%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.category"), value: 'categoryId', width: '15%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.format_type"), value: 'formatType', width: '10%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.payment_method"), value: 'paymentMethod', width: '15%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.taxes_percent"), value: 'taxesPercent', width: '5%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.gross_amount"), value: 'grossAmount', width: '5%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.total_amount"), value: 'totalAmount', width: '5%' },
                { text: this.$t("wkt.client.expensesheets.detail-window.items.attachment"), value: 'documentPath' },
                { text: '', value: 'actions', sortable: false, width: '100px' },
			],
		}
    },
	methods: {		
	},
	/*watch: {
		options: {
			handler () {
				this.$log.debug(this.options);
				this.$emit('refresh');
			},
			deep: true,
		},
	},*/
}
</script>

